<template>
    <div class="auth__validatekey">
        <auth-validate-key-form/>
    </div>
</template>

<script>
import AuthValidateKeyForm from '@/components/auth/validatekey/AuthValidateKeyForm'
export default {
  name: 'auth-validate-key',
  components: { AuthValidateKeyForm }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/validatekey/authvalidatekey";
</style>
